import { useState } from 'react';

const FILES_BASE_URL = import.meta.env.VITE_FILES_BASE_URL || 'https://www.cabaza.be/files';

// Teintes douces, écrites en toutes lettres pour que Tailwind les génère.
const TEINTES = [
    'bg-purple-100 text-purple-700',
    'bg-blue-100 text-blue-700',
    'bg-emerald-100 text-emerald-700',
    'bg-amber-100 text-amber-800',
    'bg-pink-100 text-pink-700',
    'bg-teal-100 text-teal-700'
];

const TAILLES = {
    sm: 'w-10 h-10 text-sm rounded-lg',
    md: 'w-14 h-14 text-lg rounded-xl',
    lg: 'w-24 h-24 text-3xl rounded-2xl'
};

const MOTS_VIDES = new Set(['de', 'du', 'des', 'la', 'le', 'les', 'l', 'd', 'et', 'the', 'of', 'van', 'der', 'den']);

/**
 * Les initiales d'un nom de lieu : deux lettres au plus, sans les petits mots.
 * « Rotary Club de Couvin » → « RC ».
 */
export const initialesDe = (nom) => {
    const mots = String(nom || '')
        .replace(/[’']/g, ' ')
        .split(/[\s\-–/]+/)
        .filter(Boolean)
        .filter((m) => !MOTS_VIDES.has(m.toLowerCase()));
    if (mots.length === 0) return '?';
    if (mots.length === 1) return mots[0].slice(0, 2).toUpperCase();
    return (mots[0][0] + mots[1][0]).toUpperCase();
};

// La même teinte pour le même nom, d'un affichage à l'autre.
const teinteDe = (nom) => {
    let h = 0;
    for (const c of String(nom || '')) h = (h * 31 + c.charCodeAt(0)) >>> 0;
    return TEINTES[h % TEINTES.length];
};

/**
 * La vignette d'un lieu : son logo s'il en a un, sinon ses initiales sur une
 * teinte douce. Un logo qui ne charge pas retombe sur les initiales plutôt
 * que d'afficher une image cassée.
 */
const PlaceVignette = ({ place, size = 'md', className = '' }) => {
    const [logoCasse, setLogoCasse] = useState(false);
    const nom = place?.placeName ?? place?.placename ?? place?.name ?? '';
    const logo = place?.logoPath ?? place?.logopath ?? '';
    const taille = TAILLES[size] || TAILLES.md;

    if (logo && !logoCasse) {
        return (
            <img
                src={`${FILES_BASE_URL}/${logo}`}
                alt={nom}
                onError={() => setLogoCasse(true)}
                className={`${taille} object-contain bg-white border border-gray-200 shrink-0 ${className}`.trim()}
                data-testid="place-vignette-logo"
            />
        );
    }

    return (
        <span
            className={`${taille} ${teinteDe(nom)} inline-flex items-center justify-center font-bold shrink-0 ${className}`.trim()}
            aria-label={nom}
            data-testid="place-vignette-initiales"
        >
            {initialesDe(nom)}
        </span>
    );
};

export default PlaceVignette;
